// extracted by mini-css-extract-plugin
module.exports = {"disabled":"ButtonSecondary_disabled__zlWhC","inverse":"ButtonSecondary_inverse__LCElh","default":"ButtonSecondary_default__LzUq_"};